module.exports = __webpack_public_path__ + "static/media/24_CALCINHA_FIO_DUPLO_ESTAMPADO_02.ee8df026.jpg";